
const BannerHorizontalGrande = (props) => {
    const {
        bannerId,
        isPreview,
        lazyload = 0,
        autorefresh = 0,
    } = props;

    return isPreview ? (
        <div className={`banner-preview`}>
            <p className={`banner-reserved-space`}>Banner Horizontal Grande {bannerId}</p>
        </div>
    ) : (
        <div className={`parent-banner ad-slot-background`}>
            <div 
                className={`ad-slot ad-slot-horizontal_grande`}
                id={bannerId}
                data-adtype="horizontal_grande"
                data-lazyload={lazyload}
                data-autorefresh={autorefresh}
            />
        </div>
    )
}

export default BannerHorizontalGrande;